<template>
<div id="app">
  <div class="main-container">
    <div class="site-header">
      <HeaderVue />
      <HomeNavBarVue />
    </div>
    <router-view/>
    <FooterVue class="footer" />
  </div>
  <div class="bottom-bar-container">
    <BottomBarVue />
  </div>
  <LoginModal />
  <GlobalDialog />
  <OrderCalculatorModal v-model="orderModalState.open" />
</div>
</template>


<script>
/* eslint-disable */
import { initializeApp } from "firebase/app"
import firebaseConfig from "./config/firebaseConfig"
import NavBarVue from './components/NavBar.vue'
import FooterVue from './components/Footer.vue'
import HeaderVue from './components/Header.vue'
import BottomBarVue from './components/BottomBar.vue'
import HomeNavBarVue from './components/Home/HomeNavBar.vue'
import LoginModal from './components/LoginModal.vue'
import GlobalDialog from './components/GlobalDialog.vue'
import OrderCalculatorModal from './components/OrderCalculatorModal.vue'
import { orderModalState } from './plugins/order-modal'

export default {
  name: 'App',
  components: {
    HeaderVue,
    NavBarVue,
    FooterVue,
    BottomBarVue,
    HomeNavBarVue,
    LoginModal,
    GlobalDialog,
    OrderCalculatorModal
  },
  
  data() {
    return {
      orderModalState
    }
  },

  mounted() {
    const firebaseApp = initializeApp(firebaseConfig)
  }
}

</script>


<style>
#app {
  font-family: 'Noto Sans KR', sans-serif;
  text-align: center;
  height: 100vh;
  color: #000000;
}
.main-container {
  padding-top: 30px;
  position: relative;
  width: min(700px, 100%);
  min-height: 100vh;
  margin: 0 auto;
  border: solid 1px #dadada;
  padding-bottom: 70px;
  box-sizing: border-box;
}

/* 모든 페이지 공통 헤더. 스크롤해도 화면 위에 붙어 있는다(시안 동작과 동일). */
.site-header {
  position: sticky;
  top: 0;
  z-index: 100;
  background-color: var(--bg-page, #FAFAF8);
}
.bottom-bar-container {
  position: fixed;
  width: min(700px, 100%);
  height: 60px;
  bottom: 0;
  background-color: white;
  border: solid 1px gray;
  z-index: 998;
  left: 50%;
  transform: translateX(-50%);
}

/*
  기존엔 데스크탑에서도 항상 700px 폭 + 하단 모바일 탭바로 렌더링됐다(웹뷰 전제
  설계). 새 랜딩 디자인은 데스크탑 폭(최대 1440px)의 여러 컬럼 레이아웃을
  전제로 하므로, 데스크탑 폭에서는 컨테이너를 넓히고 하단 탭바(상단 헤더/푸터가
  같은 역할을 이미 한다)를 숨긴다. 모바일 폭은 기존 그대로 둔다.
*/
@media (min-width: 900px) {
  .main-container {
    width: 100%;
    max-width: 1440px;
    border: none;
    padding-bottom: 30px;
  }
  .bottom-bar-container {
    display: none;
  }
}
</style>
